import AGREGAR_RESPONSABLES_PROYECTO from '@/graphql/mutations/administracion/control-proyectos/responsables/agregarProyectoResponsable.gql';
import REMOVER_PROYECTO_RESPONSABLE from '@/graphql/mutations/administracion/control-proyectos/responsables/removerProyectoResponsable.gql';
import PROYECTO_RESPONSABLES from '@/graphql/querys/administracion/control-proyectos/responsables/proyectoResponsables.gql';
import VALIDAR_PROYECTO_RESPONSABLE from '@/graphql/mutations/administracion/control-proyectos/responsables/validarProyectoResponsable.gql';

export default {
  apollo: {
    proyectoResponsables: {
      query: PROYECTO_RESPONSABLES,
      variables() {
        return {
          idProyecto: this.idProyecto ? this.idProyecto : '',
        };
      },
    },
  },
  methods: {
    async mixValidarProyectoResponsable(id) {
      this.mixEsCargando();

      await this.$apollo
        .mutate({
          mutation: VALIDAR_PROYECTO_RESPONSABLE,
          variables: {
            id,
          },
          update: (store, { data: { validarProyectoResponsable } }) => {
            const query = {
              query: PROYECTO_RESPONSABLES,
              variables: {
                idProyecto: this.idProyecto,
              },
            };

            const data = store.readQuery(query);
            const { proyectoResponsables } = data;
            const index = proyectoResponsables
              .findIndex((responsable) => responsable.id
              === id);
            if (index !== -1) {
              proyectoResponsables.splice(index, 1, validarProyectoResponsable);
            }
            store.writeQuery({ ...query, data });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.mixEsCargando();
    },
    async mixGuardarResponsales() {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: AGREGAR_RESPONSABLES_PROYECTO,
          variables: {
            responsables: [{ ...this.responsable }],
          },
          update: (store, { data: { agregarProyectoResponsable } }) => {
            const query = {
              query: PROYECTO_RESPONSABLES,
              variables: {
                idProyecto: this.idProyecto,
              },
            };
            const { proyectoResponsables } = store.readQuery(query);
            const proyectoResponsablesCopia = proyectoResponsables.slice();
            proyectoResponsablesCopia.push(...agregarProyectoResponsable);
            store.writeQuery({
              ...query,
              data: {
                proyectoResponsables: proyectoResponsablesCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
          this.$refs.agregarResponsableProyecto.reset();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixEliminarProyectoResponsable() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_PROYECTO_RESPONSABLE,
        variables: {
          idProyectoResponsable: this.proyectoResponsableEliminar.id,
        },
        update: (store) => {
          const query = {
            query: PROYECTO_RESPONSABLES,
            variables: {
              idProyecto: this.proyectoResponsableEliminar.idProyecto,
            },
          };
          const data = store.readQuery(query);
          const { proyectoResponsables } = data;
          const index = proyectoResponsables
            .findIndex((proyectoResponsable) => proyectoResponsable.id
            === this.proyectoResponsableEliminar.id);
          if (index !== -1) {
            proyectoResponsables.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
